import { Goal } from '../context/GoalsContext';

export const formatDate = (date: string | Date, format: string = 'MM/DD/YYYY'): string => {
  // If it's already a Date object, use it directly
  const d = date instanceof Date ? date : new Date(date);
  
  // Get the date parts from the ISO string to preserve the original date
  const [originalDate] = (typeof date === 'string' ? date : d.toISOString()).split('T');
  const [yyyy, mm, dd] = originalDate.split('-');
  
  // Format based on settings
  switch (format) {
    case 'DD/MM/YYYY':
      return `${dd}/${mm}/${yyyy}`;
    case 'YYYY-MM-DD':
      return `${yyyy}-${mm}-${dd}`;
    case 'MM/DD/YYYY':
    default:
      return `${mm}/${dd}/${yyyy}`;
  }
};

export const formatDateLong = (date: string | Date, format: string = 'MM/DD/YYYY'): string => {
  // If it's already a Date object, use it directly
  const d = date instanceof Date ? date : new Date(date);
  
  // Get the date parts from the ISO string to preserve the original date
  const [originalDate] = (typeof date === 'string' ? date : d.toISOString()).split('T');
  const [yyyy, mm, dd] = originalDate.split('-');
  
  // Create a new date using the original components
  const displayDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  // For consistency with short format
  switch (format) {
    case 'DD/MM/YYYY':
      return displayDate.toLocaleDateString('en-GB', options);
    case 'YYYY-MM-DD':
      return displayDate.toLocaleDateString('en-CA', options);
    case 'MM/DD/YYYY':
    default:
      return displayDate.toLocaleDateString('en-US', options);
  }
};

export const calculateEstimatedCompletion = (goal: Goal): string | null => {
  if (!goal.monthlyContribution || goal.monthlyContribution <= 0) {
    return null;
  }

  const remainingAmount = goal.targetAmount - goal.currentAmount;
  if (remainingAmount <= 0) {
    return new Date().toISOString();
  }

  const monthsNeeded = Math.ceil(remainingAmount / goal.monthlyContribution);
  const completionDate = new Date();
  completionDate.setMonth(completionDate.getMonth() + monthsNeeded);

  return completionDate.toISOString();
}; 